/* Publish by EComposer at 2025-07-29 14:51:15*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-o6ev8u8q54e"]=  window.__ectimmers["ecom-o6ev8u8q54e"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-o6ev8u8q54e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6ev8u8q54e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ff01vr9fjpc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ff01vr9fjpc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1yozrzicbm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1yozrzicbm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pby4nhse7om').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pby4nhse7om', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t77qqu229y9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t77qqu229y9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hlb2vqditii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hlb2vqditii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ntlnp4twzkh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ntlnp4twzkh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xj4i3w13h48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xj4i3w13h48', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94yvqqnyl8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94yvqqnyl8g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sqhbzmdvndi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sqhbzmdvndi', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2ih1is8emm1"]=  window.__ectimmers["ecom-2ih1is8emm1"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-2ih1is8emm1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ih1is8emm1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwajeyms3ob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwajeyms3ob', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ot0sf5v92c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ot0sf5v92c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p195twwk7ma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p195twwk7ma', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yr5a1d2zf29"]=  window.__ectimmers["ecom-yr5a1d2zf29"] || {};
let e=this.$el.querySelector(".ecom-shopify__article__description-view-more-btn"),r=this.settings.content_type,s=this.$el.querySelector(".ecom-shopify__article__description--full"),l=this.$el.querySelector(".ecom-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){r==="text"&&s?(s.style.display="inherit",l.style.display="none"):l.style.maxHeight=null,this.style.display="none"})

                    });
                    
                        document.querySelectorAll('.ecom-yr5a1d2zf29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yr5a1d2zf29', settings: {"content_type":"text"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}